import axios from 'axios'
import { API_KEY, API_URL } from '../keys'

export const removeImageProductById = async (
	token: string,
	productId: string,
	imageId: string
) => {
	const response = await axios.delete(
		`${API_URL}/products/images/delete?productId=${productId}&imageId=${imageId}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)
	if (response) return response
}

export const createImagesProductById = async (
	token: string,
	productId: string,
	images: File[]
) => {
	const formData = new FormData()
	images.forEach((image) => {
		formData.append('files', image)
	})

	const response = await axios.patch(`${API_URL}/products/images/create/${productId}`, formData, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'multipart/form-data',
		},
	})

    if(response) return response
}
